import React from 'react';
import PropTypes from 'prop-types';

export default function Search(props) {
  const { handleChange } = props;
  return (
    <div className="row_search">
      <div className="search col-sm">
        <input
          type="text"
          placeholder="Search by Country"
          className="form-control"
          name="searchValue"
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

Search.propTypes = {
  handleChange: PropTypes.func.isRequired,
};
